import type { ClientStage, TaskTypeName } from '@savvy/constants/generated/gql-enums';
import {
  CLIENT_STAGE_ACCOUNT_SETUP_FLOW,
  CLIENT_STAGE_FULLY_ONBOARDED,
  CLIENT_STAGE_INTAKE_FLOW,
  CLIENT_STAGE_ONBOARDING_FLOW,
  CLIENT_STAGE_POST_INTAKE_WAITING_AREA,
  CLIENT_STAGE_POST_ONBOARDING_WAITING_AREA,
} from '@savvy/constants/client-stages';

export const enum RoadmapStage {
  INTRO_CALL = 'INTRO_CALL',
  INTAKE_FLOW = 'INTAKE_FLOW',
  ACCOUNT_SETUP = 'ACCOUNT_SETUP',
  ONBOARDING_FLOW = 'ONBOARDING_FLOW',
  SIT_BACK_AND_WAIT = 'SIT_BACK_AND_WAIT',
  COMPLETED = 'COMPLETED',
}

export const BASE_CLIENT_ROADMAP_STAGE_ORDER = [
  RoadmapStage.INTRO_CALL,
  RoadmapStage.INTAKE_FLOW,
  RoadmapStage.ACCOUNT_SETUP,
  RoadmapStage.ONBOARDING_FLOW,
  RoadmapStage.SIT_BACK_AND_WAIT,
];

export const CLIENT_STAGE_TO_ROADMAP_STAGE: Record<ClientStage | 'undefined' | 'null', RoadmapStage> = {
  [CLIENT_STAGE_INTAKE_FLOW]: RoadmapStage.INTAKE_FLOW,
  [CLIENT_STAGE_POST_INTAKE_WAITING_AREA]: RoadmapStage.ONBOARDING_FLOW,
  [CLIENT_STAGE_ACCOUNT_SETUP_FLOW]: RoadmapStage.ACCOUNT_SETUP,
  [CLIENT_STAGE_ONBOARDING_FLOW]: RoadmapStage.ONBOARDING_FLOW,
  [CLIENT_STAGE_POST_ONBOARDING_WAITING_AREA]: RoadmapStage.SIT_BACK_AND_WAIT,
  [CLIENT_STAGE_FULLY_ONBOARDED]: RoadmapStage.COMPLETED,
  undefined: RoadmapStage.SIT_BACK_AND_WAIT,
  null: RoadmapStage.SIT_BACK_AND_WAIT,
};

export const ROADMAP_STAGE_TO_TASK_TYPE = {
  [RoadmapStage.INTRO_CALL]: null,
  [RoadmapStage.INTAKE_FLOW]: 'initial_intake_form',
  [RoadmapStage.ACCOUNT_SETUP]: 'account_setup',
  [RoadmapStage.ONBOARDING_FLOW]: 'onboarding_flow',
  [RoadmapStage.SIT_BACK_AND_WAIT]: null,
  [RoadmapStage.COMPLETED]: null,
} satisfies Record<RoadmapStage, TaskTypeName | null>;
